import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import logo from "../Images/Bigfreshlogo1.png";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setHovered(null);
  }, [location.pathname]);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    // { name: "Product", path: "/product" },
    {name:"Download",path:"/download"},
    { name: "Contact", path: "/contact" },
  ];

  const linkStyle = (index, path) => {
    const isActive = location.pathname === path;
    return {
      display: "inline-block",       // important!
      padding: "0.25rem 0.6rem",
      fontSize: "0.95rem",
      borderRadius: "0.3rem",
      transition: "0.3s ease",
      backgroundColor:
        hovered === index || isActive ? "#ffc107" : "transparent", // only text bg
      color:
        hovered === index || isActive ? "#000" : "#fff",
      fontWeight: isActive ? "600" : "500",
      cursor: "pointer",
      textAlign: "center",
      whiteSpace: "nowrap",         // prevents full width
    };
  };

  return (
    <>

    <Navbar
    
      expand="lg"
      sticky="top"
      
      style={{
        backgroundColor: "#34A853",
        paddingTop: "0px",
        paddingBottom: "0px",
        minHeight: "90px",
      }}
      
    >
      
      <Container className="d-flex align-items-center">
  

        {/* Logo */}
        <Navbar.Brand
          onClick={() => navigate("/")}
          style={{ cursor: "pointer", marginRight: "1rem" }}
          className="p-0"
          
          
        >
          
          <img
            src={logo}
            alt="Logo"
            style={{
              height: "6rem",
              width: "auto",
              marginTop: "-0.8rem",
              marginBottom: "-0.8rem",
            }}
                      
          />
        </Navbar.Brand>

        {/* Toggle */}
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          style={{
            backgroundColor: "#ffc107",
            border: "none",
            padding: "0.2rem",
          }}
        />

        <Navbar.Collapse id="basic-navbar-nav">

          {/* Nav Links */}
          <Nav className="mx-auto d-flex flex-column flex-lg-row align-items-center gap-2 gap-lg-3 text-center">
            {navItems.map((item, index) => (
              <Nav.Link
                key={index}
                style={linkStyle(index, item.path)}
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => navigate(item.path)}
              >
                {item.name}
              </Nav.Link>
            ))}
          </Nav>

          {/* Login Button */}
          <div
            className="d-flex justify-content-center ms-lg-3 mt-2 mt-lg-0"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/login")}
          >
            <div
              style={{
                backgroundColor: "#ffc107",
                borderRadius: "0.4rem",
                padding: "0.3rem 0.7rem",
                display: "flex",
                alignItems: "center",
                gap: "0.35rem",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}
            >
              <FaUserCircle size={15} />
              <span>Login</span>
            </div>
          </div>

        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
};

export default Header;
